import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import generateBase64 from "../../utils/generateBase64";
import { uploadAvatar } from "../../redux/actions/currentProfileActions";
import { useDispatch, useSelector } from "react-redux";
import imageCompression from "browser-image-compression";
import { loonlogAvatarSvg } from "../avatar/Avatar2";

const UploadAvatarForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [avatar, setAvatar] = useState("");
  const [processingImageLoading, setProcessingImageLoading] = useState(false);
  const [shareUpdateAsPost, setShareUpdateAsPost] = useState(false);
  const {
    avatar: currentAvatar,
    username,
    province,
  } = useSelector((state) => state.currentProfile.data);

  const handleChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setProcessingImageLoading(true);

    // const avatarOptions = {
    //   maxSizeMB: 0.2, // realistic cap (ends up 20–60 KB)
    //   maxWidthOrHeight: 400, // retina-safe
    //   quality: 0.8, // faces stay clean
    //   fileType: "image/webp",
    //   useWebWorker: true,
    // };
    // const avatarOptions = {
    //   maxSizeMB: 0.2,
    //   maxWidthOrHeight: 400,
    //   initialQuality: 0.86,
    //   quality: 0.82,
    //   fileType: "image/webp",
    //   useWebWorker: true,
    // };
    const avatarOptions = {
      maxSizeMB: 1.2,
      maxWidthOrHeight: 1600,
      initialQuality: 0.95,
      quality: 0.93,
      fileType: "image/webp",
      useWebWorker: true,
    };

    const compressionResult = await imageCompression(file, avatarOptions);

    const compressedFile = new File([compressionResult], file.name, {
      type: "image/webp",
    });

    const formData = new FormData();
    formData.append("shareUpdateAsPost", shareUpdateAsPost.toString());
    formData.append("avatar", compressedFile);
    dispatch(uploadAvatar(formData));

    const base64 = await generateBase64(file);
    setAvatar(base64);
  };

  return (
    <div className="avatar-upload-container">
      <div className="avatar-preview-wrapper">
        <input
          type="file"
          name="avatar"
          accept="image/*"
          onChange={handleChange}
        />
        {/* If there's an image, show it; otherwise show a placeholder */}
        {avatar || currentAvatar ? (
          <img
            src={avatar || currentAvatar}
            alt="avatar"
            className="avatar-image"
          />
        ) : (
          <img
            src={loonlogAvatarSvg(username, province)}
            alt="avatar"
            className="avatar-image"
          />
        )}
        {/* Floating Edit Label */}
        <div className="edit-overlay">
          <span>{t("Edit")}</span>
        </div>
      </div>
      <div
        className="display-flex align-items-c"
        style={{ marginTop: "1rem", marginLeft: "1rem" }}
      >
        <input
          type="checkbox"
          id="shareUpdateAsPost"
          checked={shareUpdateAsPost}
          onChange={(e) => setShareUpdateAsPost(e.target.checked)}
          style={{ cursor: "pointer", marginRight: "0.5rem" }}
        />
        <label
          htmlFor="shareUpdateAsPost"
          style={{ cursor: "pointer", fontSize: "0.9rem" }}
          className="text-muted"
        >
          Share profile photo updates with your followers
        </label>
      </div>
    </div>
  );
};

export default UploadAvatarForm;

